function OnsiteSearchWidget($rootScope, onsiteSearchCriteriaFactory) {

    return {
        redirect: 'E',
        replace: true,
        scope: {},
		template: require('./search-widget.html'),

        link: function (scope) {
            scope.fromDateOptions = {
                format: "MM/DD/YYYY",
                showClear: true,
                showClose: true,
                showTodayButton: true,
                useCurrent: false,
                minDate: new Date(2015, 0, 1),
                maxDate: moment().endOf('day').toDate()
            };


            scope.thruDateOptions = {
                format: "MM/DD/YYYY",
                showClear: true,
                showClose: true,
                showTodayButton: true,
                useCurrent: false,
                minDate: moment().startOf('day').toDate(),
                maxDate: moment().endOf('day').toDate()
            };

            scope.useDateRange = false;
            scope.searchCriteria = onsiteSearchCriteriaFactory.get();


            scope.clearSearch = function () {
                onsiteSearchCriteriaFactory.clear();
                scope.searchCriteria = onsiteSearchCriteriaFactory.get();
                scope.onSearchChange();
            };

            scope.onFromDateChange = function(){
                var fromDate = scope.searchCriteria.fromDate;

                if(fromDate instanceof moment){
                    fromDate = fromDate.format('MM/DD/YYYY');
                }

                var matches = fromDate ? fromDate.match(/^\d\d\/\d\d\/\d\d\d\d$/) : null;
                if(scope.searchCriteria.fromDate === null || matches){

                    scope.thruDateOptions.minDate = scope.searchCriteria.fromDate
                        ? moment(scope.searchCriteria.fromDate).startOf('day')
                        : moment("01/01/2015", "MM/DD/YYYY").startOf('day');

                    if(!scope.useDateRange){
                        scope.searchCriteria.thruDate = moment(scope.searchCriteria.fromDate).endOf('day');
                        scope.onSearchChange();
                    }else {
                        scope.onSearchChange();
                    }
                }
            };

            scope.onThruDateChange = function(){
                var thruDate = scope.searchCriteria.thruDate;

                if(thruDate instanceof moment){
                    thruDate = thruDate.format('MM/DD/YYYY');
                }

                var matches = thruDate ? thruDate.match(/^\d\d\/\d\d\/\d\d\d\d$/) : null;
                if(scope.searchCriteria.thruDate === null || matches){
                    scope.onSearchChange();
                }
            };

            scope.onSearchChange = function () {
                if(scope.searchCriteria.thruDate instanceof moment){
                    scope.searchCriteria.thruDate = scope.searchCriteria.thruDate.endOf('day');
                }

                onsiteSearchCriteriaFactory.set(scope.searchCriteria);
            };


            scope.toggleDateRange = function () {
                scope.useDateRange = !scope.useDateRange;

                scope.searchCriteria.fromDate =  scope.searchCriteria.fromDate ? moment(scope.searchCriteria.fromDate).startOf('day') : moment().startOf('day');
                scope.searchCriteria.thruDate = scope.useDateRange && scope.searchCriteria.fromDate ? moment(scope.searchCriteria.fromDate).endOf('day') : moment().endOf('day');
                scope.onSearchChange();
            };
        }
    }
}

angular.module('onsite').directive('onsiteSearchWidget', ['$rootScope', 'onsiteSearchCriteriaFactory', OnsiteSearchWidget]);
